import { render, staticRenderFns } from "./GardenerOverview.vue?vue&type=template&id=149dd97e&scoped=true"
import script from "./GardenerOverview.vue?vue&type=script&lang=js"
export * from "./GardenerOverview.vue?vue&type=script&lang=js"
import style0 from "./GardenerOverview.vue?vue&type=style&index=0&id=149dd97e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149dd97e",
  null
  
)

export default component.exports